import { DvGridComponent, DvToolbarAction } from '@devinco/ui/grid';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { DvTabBase } from '@devinco/ui/legacy';
import { GridOptionsService } from '@features/vt-grid/grid-options/grid-options.service';
import { EntityleFieldsValuesDto } from '@shared/interfaces/entity-fields-values';
import { AssetPropertiesGridService } from './asset-properties-grid.service';
import { GridOptions } from '@features/vt-grid/interfaces/grid-options';
import { FilterModelWithKeys } from '@features/vt-grid/interfaces/grid-context';
import { Entity } from '@shared/constants/entity';
import { AgGridModule } from 'ag-grid-angular';
import { DirectivesModule } from '@shared/directives/directives.module';

@Component({
  selector: 'app-asset-properties-tab',
  imports: [AgGridModule, DvGridComponent, DirectivesModule],
  providers: [GridOptionsService],
  templateUrl: './asset-properties-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetPropertiesTabComponent extends DvTabBase implements OnInit {
  private gridOptionsService = inject(GridOptionsService);
  private gridService = inject(AssetPropertiesGridService);
  private cdRef = inject(ChangeDetectorRef);

  actions: DvToolbarAction[];
  gridOptions: GridOptions<EntityleFieldsValuesDto> | undefined;

  ngOnInit(): void {
    this.actions = this.gridService.getGridActions();
  }

  onBaseActions(): void {}
  onEntityCreate(): void {}
  onEntityUpdate(): void {
    if (!this.entityId) return;

    if (!this.gridOptions) {
      this.setupGridOptions();
    } else {
      this.gridOptions.context.extraFilter = this.getFilterModel(this.entityId);
      this.gridOptions.context.loadClientSideData?.(
        this.gridOptions.context.extraFilter,
        true
      );
    }
  }

  private setupGridOptions(): void {
    this.gridOptions = this.gridOptionsService.clientSide(
      this.gridService.getColumnDefs(),
      Entity.AssetFieldsValues,
      this.getFilterModel(this.entityId)
    );
    this.cdRef.detectChanges();
  }

  private getFilterModel(entityId: string): FilterModelWithKeys {
    return {
      EntityID: {
        filterType: 'number',
        type: 'equals',
        filter: entityId,
      },
    };
  }
}
